// extracted by mini-css-extract-plugin
export default {"backgroundPrimary":"_13SeDYbV","btnBlockXs":"_2eIUF_d-","mtSm":"_3IGNYI0V","mtMd":"_1a8_GzxR","mtMdText":"_23c7E-9z","mbSm":"_1xZVOApA","btnPositionMd":"_1WCjYubM"};